// Shared fetch helpers. Extracted from App.js so components (e.g. PollCard's
// in-tile voting) can call the API without importing App.

export const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export async function fetchJson(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    ...options,
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export async function postJson(path, body) {
  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    error.status = response.status;
    try {
      const data = await response.json();
      error.detail = data.detail;
      error.body = data;
    } catch (_) {}
    throw error;
  }
  return response.json();
}

export async function postForm(path, formData) {
  const response = await fetch(`${API_BASE}${path}`, {
    method: 'POST',
    credentials: 'include',
    body: formData,
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    error.status = response.status;
    try {
      const data = await response.json();
      error.detail = data.detail;
      error.body = data;
    } catch (_) {}
    throw error;
  }
  return response.json();
}

export async function adminJson(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
    ...options,
  });
  if (!response.ok) {
    const error = new Error(`Request failed (${response.status})`);
    error.status = response.status;
    try {
      const data = await response.json();
      error.detail = data.detail;
      error.body = data;
    } catch (_) {}
    throw error;
  }
  return response.json();
}
